<template>
    <li class="pb-2" v-if="isVisible">
        <div
                :class="{bold: isFolder}"
                :style="padding"
                class="flex justify-between"
        >
            <div class="flex-no-shrink pr-2 text-blue-dark">
                <a class="cursor-pointer" @click="toggleSelect">
                    <i
                            class="fa fa-fw"
                            v-show="highlight"
                            :class="{
                            'fa-square-o': !isSelected && !isHalfSelected,
                            'fa-check-square': isSelected
                            }"
                    ></i>
                </a>
            </div>
            <div class="flex-1" :class="{'font-bold': highlight}">
                <a v-show="!isFolder" class="cursor-pointer" @click="toggleSelect">
                    {{ model.text }}
                </a>
                <span v-show="isFolder">
                    {{ model.text }}
                </span>
            </div>

        </div>

        <ul v-show="isFolder" class="pt-2 list-reset">
            <transition-expand>
                <div>
                    <database-filter-search-item
                            v-for="item in allChildren"
                            :model="item"
                            :key="item.id"
                            :depth="depth + 1"
                            :parent-path="path"
                            :folder-select="folderSelect"
                            @deselect="deselectedChild"
                            :search="search"
                            :codes="codes"
                    >
                    </database-filter-search-item>
                </div>
            </transition-expand>
        </ul>

    </li>
</template>

<script>

    import FilterItemMixin from "./FilterItemMixin";
    import TransitionExpand from "../TransitionExpand";

    export default {

        components: {
            TransitionExpand,
        },

        name: 'database-filter-search-item',

        mixins: [FilterItemMixin],

        props: ['search'],

        computed: {
            allChildren() {
                return this.getChildren(this.model);
            },
            isVisible() {
                if (this.isFolder && this.search.results.includes(this.model.id)) {
                    return true;
                }

                return this.highlight;
            },
            highlight() {
                if (this.search.value === '') {
                    return false;
                }

                return this.model.text.toLowerCase().includes(this.search.value.toLowerCase());
            },
        },

    }

</script>
